import React, { FC } from 'react';

import {
  IChallengeResourceRender,
  ILinkedText,
  ILinkedTextItem,
} from 'src/shared/models';

interface OwnProps extends IChallengeResourceRender {
  config: ILinkedText;
}

const ChallengeLinkedText: FC<OwnProps> = ({ config }) => {
  if (!config) return <React.Fragment />;
  const { arrContent } = config;

  const renderLinkedText = ({ title, link }: ILinkedTextItem) => {
    return (
      <div className="linked-text-item">
        {title}{' '}
        <a
          className="link-underscore"
          target="_blank"
          rel="noopener noreferrer"
          href={link}
        >
          aquí
        </a>
      </div>
    );
  };

  return (
    <div className="linked-text">
      {arrContent
        ?.filter(({ title, link }) => Boolean(title) && Boolean(link))
        .map((item) => renderLinkedText(item))}
    </div>
  );
};

export default ChallengeLinkedText;
